<template>
    <div v-if="props.answer.title" class="checkbox-answer-with-title" @click="handleCheck">
        <div class="checkbox" :class="{ selected }" />
        <div class="answer">
            <h4>{{ props.answer.title }}</h4>
            <p>{{ props.answer.text }}</p>
        </div>
    </div>

    <div v-else class="checkbox-answer" @click="handleCheck">
        <div class="checkbox" :class="{ selected }" />
        <p>{{ props.answer }}</p>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue';

const emit = defineEmits(['checkbox-change']);

const props = defineProps(['answer', 'initiallySelected', 'keyName']);

const selected = ref(props.initiallySelected);

const handleCheck = () => {
    selected.value = !selected.value;

    emit('checkbox-change', { selected: selected.value, key: props.keyName});
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';

.checkbox-answer-with-title {
    display: flex;
    cursor: pointer;
    margin-top: 20px;

    .checkbox {
        width: 25px;
        height: 25px;
        min-width: 25px;
        min-height: 25px;
        border: 1px solid $tetriary-color;
        border-radius: 3px;

        &.selected {
            background-color: $tetriary-color;
        }
    }

    .answer {
        display: flex;
        flex-direction: column;

        h4 {
            margin: 0 0 0 20px;
        }

        p {
            margin: 5px 0 20px 20px;
        }
    }
}

.checkbox-answer {
    display: flex;
    align-items: center;
    cursor: pointer;

    .checkbox {
        width: 25px;
        height: 25px;
        min-width: 25px;
        min-height: 25px;
        border: 1px solid $tetriary-color;
        border-radius: 3px;
        transition: 0.2s;

        &.selected {
            background-color: $tetriary-color;
        }
    }

    p {
        margin-left: 20px;
        font-size: 16px;
    }
}
</style>
